import BlSliderAv from './BlSliderAv.vue'

BlSliderAv.install = function(Vue) {
  Vue.component(BlSliderAv.name, BlSliderAv)
}

export default BlSliderAv
